import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { UzurvDirectivesModule } from '@uzurv/core';
import { CreateProviderDriverDialogComponent } from './create-provider-driver-dialog.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MatInputModule, MatDialogModule, MatButtonModule, MatIconModule, UzurvDirectivesModule],
  exports: [CreateProviderDriverDialogComponent],
  declarations: [CreateProviderDriverDialogComponent]
})
export class CreateProviderDriverDialogModule {}
